// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "Content/" + chunkId + "-" + "e38ae6df31d95b1f4bec" + ".css";
};